// removed by extract-text-webpack-plugin
module.exports = {"EmptyQueueMessage__RetryButton":"EmptyQueueMessage__RetryButton","emptyQueueMessageRetryButton":"EmptyQueueMessage__RetryButton"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/__components__/EmptyQueueMessage.scss
// module id = 570
// module chunks = 0